import { FieldProps, getIn } from 'formik';
import { useCallback, useMemo } from 'react';
import { ITextEditorProps, TextEditor } from '../components/TextEditor';

interface ITextEditorFieldProps extends FieldProps<{ html: string; plainText: string }, unknown> {
  label: ITextEditorProps['label'];
}

export const TextEditorField = ({ field, form, ...props }: ITextEditorFieldProps) => {
  const initialText = useMemo(() => field.value.html, [field.value.html]);

  const errorMessage = useMemo<{ plainText: string } | null>(
    () => (getIn(form.touched, field.name) ? getIn(form.errors, field.name) : undefined),
    [field, form],
  );

  const handleChange = useCallback(
    (html: string, plainText: string) => {
      form.setFieldValue(field.name, { html, plainText });
      form.setFieldTouched(field.name, true, true);
    },
    [form, field]
  );

  return <TextEditor {...props} errorMessage={errorMessage?.plainText} text={initialText} onChange={handleChange} />;
};
